import { drawNodeSquare } from 'rise-ui/utils/canvas/graph-shapes.js';

export function drawGraphNodes(context, nodes, options = null) {
  if (!nodes?.length) {
    return;
  }
  const {
    drawNode = drawNodeSquare,
    x: X = 'x', y: Y = 'y', size = 3,
    stroke = true, fill = true, transform,
  } = options || {};
  let x, y;
  for (let i = 0; i < nodes.length; ++i) {
    const node = transform ? transform(nodes[i]) : nodes[i];
    if (Array.isArray(node)) {
      [ x, y ] = node;
    } else {
      ({ [X]: x, [Y]: y } = node);
    }
    drawNode(context, x, y, size, stroke, fill);
  }
}
